export default __webpack_public_path__ + "e2cdd3f9cca799d5d241f78e376c85eb.svg";